import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
var PageHeader = function PageHeader() {
  return import('@/components/molecules/PageHeader');
};
var AssetListItem = function AssetListItem() {
  return import('@/components/molecules/AssetListItem');
};
var LazyImage = function LazyImage() {
  return import('@/components/atoms/LazyImage');
};
var RarityIcon = function RarityIcon() {
  return import('@/components/atoms/RarityIcon');
};
export default {
  components: {
    PageHeader: PageHeader,
    AssetListItem: AssetListItem,
    LazyImage: LazyImage,
    RarityIcon: RarityIcon
  },
  data: function data() {
    return {
      myOwnHeroType: [],
      myEthHeroType: []
    };
  },
  computed: {
    myOwnHeroIds: function myOwnHeroIds() {
      return useHeroStore().myOwnIds;
    },
    myOwnEthHeroIds: function myOwnEthHeroIds() {
      return useHeroStore().myOwnEthIds;
    },
    getHero: function getHero() {
      return useHeroStore().getHero;
    },
    isLoggedIn: function isLoggedIn() {
      return useAuthStore().isLoggedIn;
    },
    ethAddress: function ethAddress() {
      return useAuthStore().getEthAddress;
    },
    sortedHeroes: function sortedHeroes() {
      var _this = this;
      var heroes = useHeroMaster().getHeroTypes.filter(function (h) {
        return _this.isOriginal(h.heroType);
      });
      heroes.sort(function (p, c) {
        if (p.heroType < c.heroType) return -1;
        if (p.heroType > c.heroType) return 1;
        return 0;
      });
      heroes.sort(function (p, c) {
        if (p.attribute < c.attribute) return -1;
        if (p.attribute > c.attribute) return 1;
        return 0;
      });
      heroes.sort(function (p, c) {
        if ((p.rarity || 1) < (c.rarity || 1)) return 1;
        if ((p.rarity || 1) > (c.rarity || 1)) return -1;
        return 0;
      });
      return heroes;
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this2.isLoggedIn) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _context.next = 4;
            return _this2.fetchMyOwnHeroIds();
          case 4:
            _context.next = 6;
            return _this2.fetchHeroes(_this2.myOwnHeroIds);
          case 6:
            _this2.myOwnHeroIds.forEach(function (id) {
              _this2.myOwnHeroType.push(_this2.getHero(id).heroType);
            });
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    fetchHeroes: function fetchHeroes(ids) {
      return useHeroStore().fetchHeroes(ids);
    },
    fetchEthHeroIds: function fetchEthHeroIds() {
      return useHeroStore().fetchEthHeroIds();
    },
    fetchMyOwnHeroIds: function fetchMyOwnHeroIds() {
      return useHeroStore().fetchMyOwnHeroIds();
    },
    isOriginal: function isOriginal(heroType) {
      return 1000 <= heroType && heroType < 12000;
    },
    isOwned: function isOwned(heroType) {
      return this.myOwnHeroType.includes(heroType);
    },
    isOwnedInEth: function isOwnedInEth(heroType) {
      if (this.isOwned(heroType)) {
        return false;
      } else {
        return this.myEthHeroType.includes(heroType);
      }
    },
    frameSrc: function frameSrc(hero) {
      if (!hero.attribute) {
        return;
      }
      return require("~/assets/images/frames/".concat(hero.attribute, ".png"));
    }
  }
  // ,
  // head() {
  //   const head = new Head({
  //     title: `${this.$t('dictionary.heroDictionary')} | ${this.$t(
  //       'common.meta.title'
  //     )}`,
  //     url: `${this.$env.siteUrl}dictionary/heroes`
  //   })
  //   return head.get()
  // }
};